// extracted by mini-css-extract-plugin
export default {"short_title":"Services_short_title__NAOKM","main_title":"Services_main_title__QS3rR"};